<h2>{{ 'checkout.pickup.headline' | transloco }}</h2>
<div class="shipping-address-pick-up-container">
  @if ($stores(); as stores) {
    <!-- Search section -->
    <div>
      <h4 #scrollToElement>
        {{ 'checkout.pickup.searchLine' | transloco }}
      </h4>
      <div class="shipping-address-pick-up-container__search">
        <input
          #searchStoresInput
          type="text"
          class="search-input"
          placeholder="{{ 'checkout.pickup.streetAddress' | transloco }}"
          (keydown)="searchStores(false, $event)"
          [(ngModel)]="$queryModel"
          [enterKeyHint]="'search'"
        />
        <button
          (click)="searchStores(false)"
          boelsButton
          variant="secondary"
          action="none"
          [icon]="faSearch"
        >
          {{ 'checkout.pickup.searchButtonLabel' | transloco }}
        </button>
      </div>
      <button (click)="searchStores(true)" class="btn btn-my-location">
        <fa-icon [icon]="faLocation"></fa-icon>
        <span>{{ 'checkout.pickup.myLocationButtonLabel' | transloco }}</span>
      </button>
    </div>

    <!-- List section -->
    <div class="shipping-address-pick-up__list">
      <span>
        {{
          'checkout.pickup.storesFound' | transloco: { count: stores.length }
        }}
      </span>
      @for (store of stores; track store) {
        <boels-point-of-service-card
          (click)="$selectedStore.set(store)"
          [$pointOfService]="store"
          [$isActive]="$selectedStore()?.name === store.name"
          [$dayOfTheWeek]="$dayOfWeek()"
          (pointOfServiceSelected)="goNext()"
        >
        </boels-point-of-service-card>
      }
    </div>

    <!-- Button section -->
    <hr class="divider" />
    <div class="btn-container">
      <button
        boelsButton
        variant="secondary"
        action="none"
        [icon]="faChevronLeft"
        (click)="goPrevious()"
      >
        {{ 'user.back' | transloco }}
      </button>
    </div>
  } @else {
    <boels-spinner></boels-spinner>
  }
</div>
